module.exports = __webpack_public_path__ + "img/placeholder-equipment-list.c7cd6c37.svg";